// extracted by mini-css-extract-plugin
module.exports = {"container":"UserReference_container__Q6k4j"};